import { mapEventPayload } from '~api/CartAPI/utils/utils';
import CartSidebar from '~domain/entities/CartSidebar/CartSidebar';
import { ICartOverlayVisibilityProps } from '~domain/entities/CartSidebar/ICartSidebar';
import CartRepository from '~repositories/CartRepository/CartRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';

export interface ICartUpdatedPayload extends ICartOverlayVisibilityProps {
    newDisplayState: boolean;
    itemsQty?: string;
    isMobile?: boolean;
}

export default class CartUpdatedUseCase {
    private cartSidebar: CartSidebar;
    private cartRepository: CartRepository;
    private displayItemAddedText: boolean;
    private overlayProps: ICartOverlayVisibilityProps;

    constructor(overlayProps: ICartUpdatedPayload) {
        this.cartSidebar = diContainer.get(serviceNames.cartSidebar);
        this.cartRepository = diContainer.get(serviceNames.cartRepository);
        this.overlayProps = overlayProps;
        this.displayItemAddedText = overlayProps?.newDisplayState;
    }

    private async fetchCart() {
        const { response } = this.overlayProps;

        if (response) {
            const { cartItems, cartTotals, cartOrderData, miniOverlay } = mapEventPayload(response);
            this.cartSidebar.setDisplayMiniOverlay(miniOverlay);

            return this.cartRepository.setCart({ cartItems, cartTotals, cartOrderData });
        } else {
            return this.cartRepository.fetchCart();
        }
    }

    async execute() {
        try {
            this.cartSidebar.setLoading(true);
            this.cartSidebar.setVisibility(this.overlayProps);
            await this.fetchCart();
            this.cartSidebar.setDisplayItemAddedText(this.displayItemAddedText);
        } finally {
            this.cartSidebar.setLoading(false);
        }
    }
}
